import { render, staticRenderFns } from "./EditSalesOrderComponent.vue?vue&type=template&id=21835087"
import script from "./EditSalesOrderComponent.vue?vue&type=script&lang=js"
export * from "./EditSalesOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports